import format from 'string-template';

import texts from '../texts.json';
import { CAMPAIGN_FAILURE_STEP, MAX_CAMPAIGN_RECIPIENTS, MAX_IMAGE_KB } from './constants';
import { BrevoSessionUnavailableError } from './brevoAuth';
import { ImageUploadError, ImageUploadErrorCode } from './uploadCampaignImage';

const copy = texts.sections.image.errors;

const TOO_LARGE = format(copy.tooLarge, { maxKb: MAX_IMAGE_KB });

const BY_CODE = {
  [ImageUploadErrorCode.INVALID_TYPE]: copy.invalidType,
  [ImageUploadErrorCode.TOO_LARGE]: TOO_LARGE,
};

/**
 * Copy for an image that failed to validate or upload.
 * @param {Error} err The caught error.
 * @returns {string}
 */
export const imageUploadMessage = (err) => (
  err instanceof ImageUploadError ? BY_CODE[err.code] || copy.uploadFailed : copy.uploadFailed
);

/**
 * Copy for a send/save failure, falling back to the caller's generic message.
 * @param {Error} err The caught error.
 * @param {string} fallback Copy to show when the error is not one we recognise.
 * @returns {string}
 */
export const submitErrorMessage = (err, fallback) => {
  if (err instanceof BrevoSessionUnavailableError) return texts.sendStatus.brevoUnavailable;
  if (err instanceof ImageUploadError) return imageUploadMessage(err);
  if (err?.step === CAMPAIGN_FAILURE_STEP.TOO_MANY_RECIPIENTS) {
    return format(texts.sendStatus.tooManyRecipients, { max: MAX_CAMPAIGN_RECIPIENTS });
  }
  return fallback;
};
